module.exports = __webpack_public_path__ + "img/success.3b61f85c.png";